import React, { useEffect } from "react";
import { TextView } from "@components";
import CanvasCard from "../../Shared/Card"
import { Grid } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { toggleSegmentSettings } from "../../../../redux/actions/segmentSettings.js";


const ToolbarBody = ({ data = [] }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(toggleSegmentSettings(false));
  }, []);

  return (
    <>
      {data?.length ? (
        data?.map((d) => (
          <>
            <Grid key={d?.id} container marginTop={2}>
              <TextView
                variant={"subtitle"}
                style={{ marginTop: 10, marginBottom: -10 }}
              >
                {d.title}
              </TextView>
              <CanvasCard
                backgroundColor={d?.backgroundColor}
                data={d?.elements}
              />
            </Grid>
          </>
        ))
      ) : (
        <></>
      )}
    </>
  );
};

export default ToolbarBody;
